import React, { useContext } from 'react';
import { AuthContext, useAuth } from './AuthenticationProvider'; // Importar el Provider
import { WithAuthProps } from './WithAuthProps';

interface Props {
  children: React.ReactNode;
}

function withAuth<T>(Component: React.ComponentType<T & WithAuthProps>) {
  return (props: Omit<T, keyof WithAuthProps>) => {
    const context = useContext(AuthContext);

    if(!context) {
      throw new Error('withAuth must be used within a AuthenticationProvider');
    }

    const account = {
      isAuthenticated: context.isAuthenticated,
      id: context.id,
      name: context.name,
      logout: context.logout,
      loading: context.loading,
    }

    return <Component {...(props as T)} account={account} />;
  };
}

export default withAuth;
// // Este HOC protegerá las páginas que necesitan autenticación
// const withAuth = (Component: React.FC<Props>): React.FC<Props> => {
//   return (props) => {
//     const { isAuthenticated } = useAuth();

//     // Si el usuario no está autenticado, redirigirlo a la página de inicio de sesión o pública
//     if (!isAuthenticated) {
//       return <div>No tienes acceso a esta página. Por favor, inicia sesión.</div>;
//     }

//     // Si está autenticado, renderizar el componente protegido
//     return <Component {...props} />;
//   };
// };

// export default withAuth;
